"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processGetIntersectingChildren = exports.processSearchFeatures = exports.processNestedFeatures = exports.processSplitFeatures = exports.processPreUpdateFeatures = exports.processInheritanceParents = exports.processExternalFeatures = exports.processFeatures = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
const standardizeFeature_1 = require("./standardizeFeature");
/*
 * feature attribute names cannot be camelcased, so we must be more surgical when camelcasing
 * responses that contain feature attributes as keys.
 *
 * V2 Fibermap has historically renamed feature 'properties' property to 'attributes'.
 */
function processFeatures(resp, reassignAttributes = false) {
    if (Array.isArray(resp.data.result)) {
        resp.data.result = resp.data.result.map((f) => (0, standardizeFeature_1.standardizeFeature)(f, reassignAttributes));
    }
    else {
        resp.data.result = (0, standardizeFeature_1.standardizeFeature)(resp.data.result, reassignAttributes);
    }
}
exports.processFeatures = processFeatures;
function processExternalFeatures(resp, reassignAttributes = false) {
    resp.data.result = (0, lodash_mapvalues_1.default)(resp.data.result, (featureArray) => featureArray.map((f) => (0, standardizeFeature_1.standardizeFeature)(f, reassignAttributes)));
}
exports.processExternalFeatures = processExternalFeatures;
function processInheritanceParents(resp, reassignAttributes = false) {
    const result = (0, camelcase_keys_1.default)(resp.data.result, {
        deep: true,
        stopPaths: ['source_features'],
    });
    resp.data.result = result.map((r) => (Object.assign(Object.assign({}, r), { sourceFeatures: r.sourceFeatures.map((f) => (0, standardizeFeature_1.standardizeFeature)(f, reassignAttributes)) })));
}
exports.processInheritanceParents = processInheritanceParents;
function processPreUpdateFeatures(resp, reassignAttributes = false) {
    const result = (0, camelcase_keys_1.default)(resp.data.result, {
        deep: true,
        stopPaths: ['features'],
    });
    result.features = resp.data.result.features.map((f) => ({
        feature: (0, standardizeFeature_1.standardizeFeature)(f.feature, reassignAttributes),
        nodes: (0, camelcase_keys_1.default)(f.nodes, { deep: true }),
    }));
    resp.data.result = result;
}
exports.processPreUpdateFeatures = processPreUpdateFeatures;
function processSplitFeatures(resp, reassignAttributes = false) {
    resp.data.result.lines = resp.data.result.lines.map((f) => (0, standardizeFeature_1.standardizeFeature)(f, reassignAttributes));
    resp.data.result.points = resp.data.result.points.map((f) => (0, standardizeFeature_1.standardizeFeature)(f, reassignAttributes));
}
exports.processSplitFeatures = processSplitFeatures;
function processNestedFeatures(resp, reassignAttributes = false) {
    const data = (0, camelcase_keys_1.default)(resp.data, {
        deep: true,
        stopPaths: ['result.ancestors', 'result.descendants'],
    });
    data.result.ancestors.forEach((a) => {
        a.feature = (0, standardizeFeature_1.standardizeFeature)(a.feature, reassignAttributes);
    });
    data.result.descendants.forEach((d) => {
        d.feature = (0, standardizeFeature_1.standardizeFeature)(d.feature, reassignAttributes);
    });
    resp.data = data;
}
exports.processNestedFeatures = processNestedFeatures;
function processSearchFeatures(resp) {
    const { items } = resp.data.result;
    resp.data.result.items = items.map((item) => (0, camelcase_keys_1.default)(item, { deep: true, stopPaths: ['attributes'] }));
}
exports.processSearchFeatures = processSearchFeatures;
function processGetIntersectingChildren(resp) {
    resp.data.result = resp.data.result.map(({ parent, child }) => ({
        parent: (0, standardizeFeature_1.standardizeFeature)(parent),
        child: (0, standardizeFeature_1.standardizeFeature)(child),
    }));
}
exports.processGetIntersectingChildren = processGetIntersectingChildren;
//# sourceMappingURL=features.js.map